// Flutterwave Configuration
export const FLUTTERWAVE_CONFIG = {
  publicKey: 'FLWPUBK-04111a7fd59ac135a0fe0425adb99e5e-X',
  clientId: 'd55d07be-1329-4ed3-b8fb-237365c053b3',
  secretKey: 'AnrOSp5j1T0VAxYUs3Wl1SCrGeJGMoe3',
  encryptionKey: 'anCUo6R9jgiskPe32yWFSeRJjL3Kz9hdwy4UF24Ykmo=',
  baseUrl: 'https://api.flutterwave.com/v3',
  currency: 'NGN',
  country: 'NG'
};

// Flutterwave Payment Helper Functions
export const initializeFlutterwave = () => {
  return new Promise((resolve, reject) => {
    if (window.FlutterwaveCheckout) {
      resolve(window.FlutterwaveCheckout);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.flutterwave.com/v3.js';
    script.onload = () => resolve(window.FlutterwaveCheckout);
    script.onerror = () => reject(new Error('Failed to load Flutterwave script'));
    document.head.appendChild(script);
  });
};

export const createFlutterwavePayment = async (paymentData) => {
  try {
    const FlutterwaveCheckout = await initializeFlutterwave();
    
    const paymentConfig = {
      public_key: FLUTTERWAVE_CONFIG.publicKey,
      tx_ref: paymentData.tx_ref || `tx_${Date.now()}`,
      amount: paymentData.amount,
      currency: paymentData.currency || FLUTTERWAVE_CONFIG.currency,
      payment_options: 'card,mobilemoney,ussd',
      redirect_url: paymentData.redirect_url || window.location.origin + '/payment-success',
      customer: {
        email: paymentData.customer.email,
        phone_number: paymentData.customer.phone_number,
        name: paymentData.customer.name,
      },
      customizations: {
        title: paymentData.customizations?.title || 'Payment',
        description: paymentData.customizations?.description || 'Complete your payment',
        logo: paymentData.customizations?.logo || '',
      },
      meta: paymentData.meta || {},
    };

    return new Promise((resolve, reject) => {
      FlutterwaveCheckout({
        ...paymentConfig,
        callback: (response) => {
          if (response.status === 'successful') {
            resolve(response);
          } else {
            reject(new Error('Payment failed'));
          }
        },
        onclose: () => {
          reject(new Error('Payment cancelled'));
        },
      });
    });
  } catch (error) {
    console.error('Flutterwave payment error:', error);
    throw error;
  }
};

export default FLUTTERWAVE_CONFIG;
